export default __webpack_public_path__ + "45e127a13e2f3c5f37ed34b90dac7b2f.png";